import Swal from "sweetalert2";
import "./index.css";
export const DialogMessage = Swal.mixin({
    customClass: {
        confirmButton: 'primary',
        cancelButton: ''
    },
})  